const VITE_UNITY_URL = import.meta.env.VITE_UNITY_URL;

export const allRoutes: IRoute[] = [
  {
    id: 'json',
    path: '/json/*',
    elementId: 'PageJson',
    isPublic: false,
    props: {},
  },
  {
    id: 'login',
    path: '/login/*',
    elementId: 'PageLogin',
    isPublic: true,
    props: {},
  },
  {
    id: 'editor',
    path: '/editor/*',
    elementId: 'PageEditor',
    isPublic: false,
    props: {},
  },
  {
    id: 'mobile',
    path: '/mobile/:projectId/:modelId',
    elementId: 'PageMobile',
    isPublic: true,
    props: {},
  },
  {
    id: 'wireframes',
    path: '/wireframes/*',
    elementId: 'PageWireframes',
    isPublic: true,
    props: {},
  },
  {
    id: 'embed',
    path: '/embed/:projectId/:modelId',
    elementId: 'PageEmbed',
    isPublic: true,
    props: {},
  },
  {
    id: 'plaform',
    path: '/platform/*',
    elementId: 'PagePlatform',
    props: {},
  },
  {
    id: 'playground-category',
    path: '/playground/:category',
    elementId: 'PagePlayground',
    isPublic: false,
    props: {},
  },
  {
    id: 'playground-item',
    path: '/playground/:category/:id',
    elementId: 'PagePlayground',
    isPublic: false,
    props: {},
  },
  {
    id: 'changelog',
    path: '/changelog',
    elementId: 'PageChangeLog',
    isPublic: false,
    props: {},
  },
  {
    id: 'landing-b2c',
    path: '/landing/b2c',
    elementId: 'PageLanding',
    isPublic: true,
    props: {},
  },
  {
    id: 'landing-b2b',
    path: '/landing',
    elementId: 'PageLandingB2b',
    isPublic: true,
    props: {},
  },
  {
    id: 'labs',
    path: '/labs/*',
    elementId: 'PageLabs',
    isPublic: false,
    props: {},
  },
  {
    id: 'demos',
    path: '/demos/*',
    elementId: 'PageDemos',
    isPublic: false,
    props: {},
  },
  {
    id: 'story',
    path: '/story',
    elementId: 'PageStory',
    isPublic: true,
    props: {},
  },
  {
    id: 'logout',
    path: '/logout',
    elementId: 'PageLogout',
    isPublic: false,
    props: {},
  },
  {
    id: 'viewer',
    path: '/viewer',
    elementId: 'Viewer',
    isPublic: true,
    props: {
      buildUrl: VITE_UNITY_URL,
      id: 'raw2',
    },
  },
  {
    id: 'viewer-raw',
    path: '/viewer/raw/:instanceId',
    elementId: 'ViewerRaw',
    isPublic: true,
    props: {
      buildUrl: VITE_UNITY_URL,
    },
  },
  {
    id: 'recorder',
    path: '/recorder/:generatorIndex',
    elementId: 'PageRecorder',
    isPublic: false,
    props: {},
  },
  {
    id: 'mobile',
    path: '/mobile/:projectId/:modelId',
    elementId: 'PageRecorder',
    isPublic: false,
    props: {},
  },
  {
    id: 'labs-fallback',
    path: '/labs/*',
    elementId: 'PageLabs',
    isPublic: false,
    props: {},
  },
  {
    id: 'default-fallback',
    path: '/*',
    elementId: 'PageHome',
    isPublic: false,
    props: {},
  },
];
